<form [formGroup]="postInfoForm">
  <div class="form-group">
    <label [class.font-md]="smallLabel"
           [class.font-xl]="!smallLabel"
           class="fw-bold"
           [translate]="'common.invoicePostInfo.address.title'">Invoice address</label>
    <input [placeholder]="'common.invoicePostInfo.address.placeholder' | translate" class="form-control"
           formControlName="invoiceAddress"
           maxlength="128"
           type="text">
    <div class="d-flex justify-content-between mt-3 mb-2 w-100">
      <div class="w-30">
        <label [class.font-md]="smallLabel"
               [class.font-xl]="!smallLabel"
               class="fw-bold"
               [translate]="'common.invoicePostInfo.postNumber.title'">Post number</label>
        <input [placeholder]="'common.invoicePostInfo.postNumber.placeholder' | translate"
               class="form-control" formControlName="invoicePostNumber" type="text">
      </div>
      <div class="w-65">
        <label [class.font-md]="smallLabel"
               [class.font-xl]="!smallLabel"
               class="fw-bold"
               [translate]="'common.invoicePostInfo.postArea.title'">Post area</label>
        <input [placeholder]="'common.invoicePostInfo.postArea.placeholder' | translate" class="form-control"
               formControlName="invoicePostArea"
               type="text">
      </div>
    </div>
  </div>
</form>
